"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LadderFlowPosition = void 0;
class LadderFlowPosition {
    constructor() {
        this.inAmount = 0;
        this.outAmount = 0;
        this.netAmount = 0;
    }
}
exports.LadderFlowPosition = LadderFlowPosition;
//# sourceMappingURL=ladder-flow-position.js.map